import { geojsonToArcGIS } from '@terraformer/arcgis';
import type { Units } from '@turf/turf';
import type { GeoJsonProperties, MultiPolygon, Polygon } from 'geojson';
import { TOCLegendParentMap } from '~/store2/TOCLayers';

export type TurfOptions =
  | {
      units?: Units | undefined;
      properties?: GeoJsonProperties | undefined;
    }
  | undefined;

export const BOUNDARY_COLOR = {
  green: 'rgb(0, 255, 0)',
  red: 'rgb(255, 0, 0)',
  teal: 'rgb(42, 192, 132)',
};

export const getSelectedLayersText = (layerIds: Set<string>): string => {
  const size = layerIds.size;

  if (size > 0) {
    return size === 1 ? '1 Layer Selected' : `${size} Layers Selected`;
  }

  return 'No Layers Selected';
};

export const getTOCParentSection = (layerId: string) => {
  const section = TOCLegendParentMap.get(layerId);
  if (section) {
    return section.split('/')[0].trim();
  }
};
